import { makeStyles } from "@material-ui/core/styles";

export const createUserStyles = makeStyles((theme) => ({
  containedor: {
    top: 0,
    position: "relative",
    display: "flex",
    justifyContent: "center",
    "& form": {
      [theme.breakpoints.up("md")]: {
        width: "500px",
      },
      [theme.breakpoints.down("md")]: {
        width: "350px",
      },
    },
  },
  input: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: 16,
  },
  helperText: {
    position: "absolute",
    fontFamily: "Inter",
    fontWeight: "100",
    fontSize: "12px",
    color: "#d41212",
    top: "100%",
    right: "5px",
  },
  inputContainer: {
    position: "relative",
    marginBottom: "30px",
  },
  title: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "24px",
    color: "#0F172A",
    marginBottom: "8px",
  },
  promotionCode: {
    margin: "5px 0 30px 0",
  },
  link: {
    color: "#0344DC",
    textDecoration: "none",
    display: "flex",
    alignContent: "center",
    fontSize: theme.typography.pxToRem(14),
  },
}));
